var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.size.match(/^(xs|sm)$/))?_c('div',{staticClass:"ball-pulse-sync loader",class:{ [_vm.size]: true, [_vm.color]: true }},_vm._l((3),function(index){return _c('div',{key:index})}),0):_c('div',{staticClass:"loader",class:{ [_vm.size]: true, [_vm.color]: true }},[_c('img',{attrs:{"src":require("@/assets/img/flying-dragon.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }